@if (showRecipeByLabel && (isSmall || isMobile$) && !isLoading) {
  <span class="is-overline c__label">
    {{ "recipes.timer.recipeBy" | translate }}
  </span>
}

<div class="c__user-wrapper">
  @if (user?.type === 'UGC') {
    <sd-icon name="icon-account" [size]="iconSize.logo" />
  }
  @if (user?.type !== 'UGC' && (user?.image?.url || user?.image?.urlTwicPic)) {
    <sd-banner [media]="user?.image" [isComponentLoading]="isLoading" />
  }
  @if (!isLoading) {
    @if (showRecipeByLabel && !isSmall && !isMobile$) {
      <span class="is-overline c__label">
        {{ "recipes.timer.recipeBy" | translate }}
      </span>
    }
    <span class="{{(isSmall) ? 'brand--h6' : 'brand--h5'}} c__recipe-owner">
      {{ user.text }}
    </span>
  }

  @if (isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.line"
      [sizeChangeMobile]="false"
      [count]="2"
    />
  }
</div>
